import * as React from "react"
import type { SVGProps } from "react"
const SvgPaintBucket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.65 20.5 2.5 14.35a2 2 0 0 1-.37-.55 1.6 1.6 0 0 1 0-1.25q.12-.3.37-.55l5.75-5.73L6.38 4.4a1 1 0 0 1-.34-.77q-.01-.45.31-.8.33-.35.8-.35.49 0 .82.35L17.16 12q.26.25.36.55a1.8 1.8 0 0 1 0 1.25 2 2 0 0 1-.36.55L11 20.5a2 2 0 0 1-.55.38 1.6 1.6 0 0 1-1.25 0 2 2 0 0 1-.55-.38M9.82 7.85 4.47 13.2h10.7zM19.8 21q-.9 0-1.52-.64a2.2 2.2 0 0 1-.63-1.56q0-.67.34-1.27t.76-1.18l.48-.6a.8.8 0 0 1 .58-.29.7.7 0 0 1 .59.27l.5.62q.4.57.75 1.18.35.6.35 1.27a2 2 0 0 1-.65 1.56q-.65.64-1.55.64" />
  </svg>
)
export default SvgPaintBucket
